import { render, staticRenderFns } from "./SendReply.vue?vue&type=template&id=6c0e15ce&"
import script from "./SendReply.vue?vue&type=script&lang=js&"
export * from "./SendReply.vue?vue&type=script&lang=js&"
import style0 from "./SendReply.vue?vue&type=style&index=0&id=6c0e15ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports